export default {
  "cancelorderMap": {
    0: "Δεν το θέλω.",
    1: "Τοποθέτησε λάθος το προϊόν",
    2: "Διπλότυπη παραγγελία",
    3: "Η λήψη απέτυχε",
    4: "Αλλοι λόγοι"
  },
  "获取验证码": "Λάβετε τον κωδικό",
  "请输入验证码": "Εισαγάγετε τον κωδικό",
  "验证码": "Κωδικός επιβεβαίωσης",
  "发送":"SEND",
  "已发送，请注意查收": "Αποστέλλοντας, ενημερώστε σας",
  "加值": "Προσθήκη",
  "备注": "Σημείωση",
  "当前余额": "Τρέχον υπόλοιπο",
  "银行卡": "Κάρτα τραπέζης",
  "联系商家": "Επικοινωνήστε με τον πωλητή",
  "提领": "Ανάκτηση",
  "平台人工发起退款": "Η πλατφόρμα εκκίνησε την επιστροφή χρημάτων",
  "电商批发商场": "Ηλεκτρονική αγορά χονδρικής πώλησης",
  "请输入完整的支付密码!" : "Εισαγάγετε τον πλήρη κωδικό πληρωμής!",
  "最多上传9张图片": "Μέγιστο 9 εικόνες",
  "账号注销": "Ακύρωση λογαριασμού",
  "确定注销": "Επιβεβαίωση ακύρωσης",
  "加密货币": "Κρυπτονόμισμα",
  "银行卡": "Κάρτα τραπέζης",
  '参数缺失': 'Λείπουν παράμετροι',
  '充值数量必填': 'Το ποσό επαναφόρτισης είναι υποχρεωτικό',
  "充值币种": "Νόμισμα επαναφόρτισης",
  "充值金额": "Ποσό επαναφόρτισης",
  "充值金额不得小于": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μικρότερο από",
  "充值金额不得大于": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μεγαλύτερο από",
  "请先选择币种": "Επιλέξτε πρώτα το νόμισμα",
  "开户行": "Τράπεζα",
  "请输入开户行名称": "Εισαγάγετε το όνομα της τράπεζας",
  "银行卡号": "Αριθμός κάρτας",
  "请输入银行卡号": "Εισαγάγετε τον αριθμό της κάρτας",
  "点击去支付": "Κάντε κλικ για πληρωμή",
  "企业证明": "Πιστοποιητικό επιχείρησης",
  "您的账号": "Ο λογαριασμός σας",
  "为什么要离开": "Γιατί να φύγετε",
  "您还有余额,不能注销账号": "Υπάρχει ακόμα υπόλοιπο στον λογαριασμό σας, δεν μπορείτε να ακυρώσετε τον λογαριασμό!",
  "请输入注销理由": "Εισαγάγετε τον λόγο ακύρωσης",
  "您确认要注销吗?": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε τον λογαριασμό σας;",
  "我再考虑下": "Θα σκεφτώ ξανά",
  "同意注销": "Συμφωνώ με την ακύρωση",
  "注销成功": "Επιτυχής ακύρωση",
  "cancelInfo":"προειδοποιώ! Προσέξτε να ακυρώσετε τον λογαριασμό. Εάν δεν χρησιμοποιείτε πλέον τον λογαριασμό, μπορείτε να κάνετε κλικ στο [Agree to Cancellation]. Ενδέχεται να μην μπορείτε να εγγραφείτε εντός λίγων ημερών μετά την ακύρωση.",
  "App下载(买家端)": "Λήψη App (Αγοραστής)",
  "App下载(卖家端)": "Λήψη App (Πωλητής)",
  recommendclass:"Προτείνετε κατηγορία",
  "滑动验证": "Επιβεβαίωση κύλισης",
  "用户未发表评论": "Ο χρήστης δεν έχει σχολιάσει",
  "订单": "Σειρά",
  "下单成功，等待付款": "Η παραγγελία ολοκληρώθηκε με επιτυχία, σε αναμονή για πληρωμή",
  "下单成功，付款成功": "Η παραγγελία πραγματοποιήθηκε με επιτυχία, η πληρωμή ολοκληρώθηκε",
  "已发货，正在运输中": "Αποστέλλεται, κατά τη μεταφορά",
  "订单已取消，原因:手动发起取消订单": "Η παραγγελία ακυρώθηκε. Αιτία: Ακύρωση της παραγγελίας με μη αυτόματο τρόπο.",
  "订单已取消，原因:超时自动取消订单": "Η παραγγελία ακυρώθηκε. Αιτία: Η παραγγελία θα ακυρωθεί αυτόματα μετά το χρονικό όριο.",
  "商家已确认，已进入备货状态": "Ο έμπορος έχει επιβεβαιωθεί και έχει εισέλθει στο απόθεμα.",
  "系统发货成功": "Η παράδοση του συστήματος πέτυχε",
  "长时间未付款，系统自动取消订单": "Η πληρωμή δεν έχει πραγματοποιηθεί για μεγάλο χρονικό διάστημα και η παραγγελία θα ακυρωθεί αυτόματα.",
  "订单已签收": "Εντολή Ελήφθη",
  "发起退款申请": "Ξεκινήστε ένα αίτημα επιστροφής χρημάτων",
  "退款成功": "Επιτυχής επιστροφή χρημάτων",
  "退款失败": "Η επιστροφή χρημάτων απέτυχε",
  "订单退款成功": "Επιτυχής επιστροφή χρημάτων παραγγελίας",
  "订单退款失败": "Η επιστροφή χρημάτων παραγγελίας απέτυχε",
  "系统默认好评": "Το σύστημα προεπιλογή για ευνοϊκές κριτικές",
  "请输入关键字搜索": "Εισαγάγετε λέξη-κλειδί για αναζήτηση",
  "mailboxCheck": "Συμπληρώστε τη σωστή διεύθυνση email",
  "猜你喜欢": "Μαντέψτε ότι σας αρέσει",
  "订单已完成": "Η παραγγελία ολοκληρώθηκε",
  "热销推荐": "Καυτή σύσταση πώλησης",
  "头像选择": "Επιλογή Avatar",
  "修改头像": "Τροποποιήστε το avatar σας",
  subOrder: "Υποβάλετε την παραγγελία",
  "switchLang": "Μεταβείτε σε άλλη γλώσσα για προβολή",
  "myCart": "Το καλάθι αγορών μου",
  "notQua": "Δεν πληρούνται οι προϋποθέσεις πρόκρισης.",
  "noSmaller": "Το ποσό που εφαρμόζεται δεν μπορεί να είναι μικρότερο από",
  "nomax": "Το μέγιστο ποσό αίτησης δεν μπορεί να υπερβαίνει",
  "evaluationUploading": "Έχετε ακόμα φωτογραφίες για μεταφόρτωση. Παρακαλώ δοκιμάστε ξανά αργότερα",
  "evaluateInput": "Κριτική με εικόνες",
  "moneyOrderStatus": "Κατάσταση παραγγελίας",
  "coinBlock": "Συναλλαγματική συμφωνία",
  "dealing": "Σε εξέλιξη",
  "dealSuccess": "Επιτυχής",
  "dealFail": "Αποτυγχάνω",
  "payCertificate": "Πιστοποιητικό πληρωμής",
  "handleFee": "Χρέωση υπηρεσίας",
  "highOpinion": "Καλές κριτικές",
  "mediumOpinion": "Μεσαία κριτική",
  "lowOpinion": "Κακές κριτικές",
  "hasImage": "Με εικόνες",
  "rechargeMethod": "Λειτουργία επαναφόρτισης",
  "scanAndDown": "Σάρωση κωδικού QR Λήψη APP",
  "receivedAddress": "Διεύθυνση απόδειξης",
  "ActualLedger": "Πραγματική απόδειξη",
  "view": "Θέα",
  "withdrawNum": "Ποσότητα ανάληψης μετρητών",
  "rechargeNum": "Ποσότητα επαναφόρτισης",
  "date": "Ημερομηνία",
  "walletHistory": "Ιστορικό πορτοφολιού",
  "accountBalance": "Υπόλοιπο λογαριασμού",
  "accountReview": "Σύνοψη λογαριασμού",
  "rated": "Αξιολογήθηκε",
  "receiver": "Δέκτης",
  "orderStatus": "Κατάσταση",
  "orderTime": "χρόνος",
  "tax": "Φορολογία",
  "discount": "Εκπτωση",
  "productInfo": "Πληροφορίες Προϊόντος",
  "paramError": "Σφάλμα παραμέτρου",
  "orderInfo": "Πληροφορίες Παραγγελίας",
  "rebuy": "Άλλη μια παραγγελία",
  "pleaseCorrectAddress": "Εισαγάγετε τη σωστή διεύθυνση ανάληψης μετρητών",
  "pleaseInputCorrectNumber": "Εισαγάγετε έναν αριθμό μεγαλύτερο από 0",
  "vcodePass": "Η επαλήθευση πέρασε!",
  "vcodeFail": "Η ταυτοποίηση απέτυχε. Παρακαλώ προσπάθησε ξανά",
  "uploading": "Μεταφόρτωση...",
  "uploadSuccess": "Η μεταφόρτωση ολοκληρώθηκε",
  "uploadError": "Η μεταφόρτωση απέτυχε. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα",
  "registerSuccess": "Η εγγραφή πέτυχε",
  "pleaseSetMobileNumber": "Ορίστε τον αριθμό τηλεφώνου",
  "unSelectedProduct": "Δεν έχετε επιλέξει προϊόν",
  "loginSuccess": "Η σύνδεση πέτυχε",
  "pleaseSetAreaCode": "Εισαγάγετε το όνομα της χώρας και τον κωδικό περιοχής για αναζήτηση",
  "login": "Σύνδεση",
  "register": "Εγγραφή",
  "logout": "Εξοδος",
  "noData": "Δε βρέθηκαν δεδομένα",
  "search": "Αναζήτηση",
  "historySearch": "Ιστορική αναζήτηση",
  "empty": "Αδειάζω",
  "home": "Αρχική σελίδα",
  "favorableRate": "Ποσοστό καλών κριτικών",
  "classification": "Κατηγορία",
  "searchTips": "Αναζήτηση πηγής/προϊόν/προμηθευτής/παραγγελία",
  "dailyNewArrival": "Καθημερινά παρατίθενται νέα προϊόντα",
  "more": "Περισσότερο",
  "recommend": "Σύσταση",
  "recommendedProducts": "Προτεινόμενα προϊόντα",
  "recommendedStore": "Προτεινόμενα καταστήματα",
  "buyNow": "Αγορά τώρα",
  "addCart": "Προσθήκη στο καλάθι αγορών",
  "complex": "Ολοκληρωμένο",
  "price": "Τιμή",
  "retailPrice": "Τιμή λιανικής",
  "originPrice": "Αρχική τιμή",
  "service": "Εξυπηρέτηση πελατών",
  "collect": "Αγαπημένα",
  "sold": "Ογκος ΠΩΛΗΣΕΩΝ",
  "pageviews": "Ποσότητα περιήγησης",
  "quantity": "Ποσότητα",
  "freight": "Φορτίο",
  "shipping": "Αποστολή",
  "ship": "Σκάφος",
  "buyTips": "Αποστολή εντός 24 ωρών από την υποβολή της παραγγελίας. Οι παρακάτω παραγγελίες είναι υπό έλεγχο logistics και ενδέχεται να αποσταλούν καθυστερημένα. Παρακαλούμε δώστε προσοχή στις πληροφορίες logistics ή επικοινωνήστε με την εξυπηρέτηση πελατών.",
  "totalPrice": "Συνολικό ποσό",
  "addCartMessage": "Προστέθηκε με επιτυχία στο καλάθι αγορών",
  "addCartMessageFaild": "Το προϊόν υπάρχει ήδη στο καλάθι αγορών.",
  "myAccount": "Ο λογαριασμός μου q",
  "buyHistory": "Εγγραφές αγορών",
  "wishlist": "Αγαπημένα προϊόντα",
  "trackOrder": "Σειρά",
  "account": "Λογαριασμός:",
  "sellerZone": "Εμπορική περιοχή",
  "beSeller": "Γίνε έμπορος",
  "sellerPanelLogin": "Είσοδος εμπόρου",
  "footTip": "© Πνευματικά δικαιώματα {name} Ltd 2024",
  "footTips": "Η {name} Limited είναι εξουσιοδοτημένη και ελέγχεται από την Αρχή Χρηματοοικονομικής Συμπεριφοράς ως μεσίτης πιστώσεων (713206) και συναλλάσσεται αποκλειστικά με τον δανειστή Home Retail Group CardServices Limited ως {name} Financial Services. Η {name} Financial Services είναι εξουσιοδοτημένη και ελέγχεται από την Αρχή Χρηματοοικονομικής Συμπεριφοράς για την παροχή πίστωσης (716148). Η Home Retail GroupCard Services Limited είναι εγγεγραμμένη στο Ηνωμένο Βασίλειο (04007072) στο Avebury, 489-499 Avebury Boulevard, Milton Keynes, Ηνωμένο Βασίλειο. ΜΚ9 2ΒΔ.",
  "item": "Αρθρο",
  "checkout": "Κάνετε μια παραγγελία",
  "productDescription": "περιγραφή προϊόντος",
  "userEvaluation": "Κριτικές χρηστών",
  "AllProducts": "Ολα τα προϊόντα",
  "followers": "Ακολουθηστε",
  "sales": "Ογκος ΠΩΛΗΣΕΩΝ",
  "visitStore": "Επισκεφθείτε το κατάστημα",
  "authentic": "100% Γνήσιο",
  "dayReturns7": "7 ημέρες επιστροφή",
  "shippingDiscounts": "Έκπτωση φορτίου",
  "safePayment": "Ασφαλής πληρωμή",
  "followed": "Ακολούθησαν",
  "dashboard": "Πίνακας οργάνων",
  "myOrder": "Η παραγγελία μου",
  "setUp": "Ρύθμιση",
  "successTips": "Επιτυχής",
  "copySuccess": "Η αναπαραγωγή πέτυχε",
  "balance": "Υπόλοιπο (USDT)",
  "sort": "Τύπος",
  "commodity": "Προϊόν",
  "browse": "Ογκος ΠΩΛΗΣΕΩΝ",
  "recharge": "Επαναφόρτιση",
  "commodityCollection": "Συλλογή προϊόντων",
  "withdraw": "ΑΝΑΛΗΨΗ ΜΕΤΡΗΤΩΝ",
  "defaultAddress": "Προεπιλεγμένη διεύθυνση",
  "addNewAddress": "Προσθήκη νέας διεύθυνσης",
  "withdrawRecord": "Ρεκόρ ανάληψης μετρητών",
  "serialNumber": "Αριθμός παραγγελίας.",
  "time": "χρόνος",
  "amount": "Ποσό",
  "processing": "Σε εξέλιξη",
  "fail": "Αποτυγχάνω",
  "blockchainNetwork": "Δίκτυο Blockchain",
  "records": "Ρεκόρ",
  "withdrawAddress": "Διεύθυνση ανάληψης μετρητών",
  "withdrawInputTips": "Εισαγάγετε τη διεύθυνση ανάληψης",
  "copy": "Αντιγραφή",
  "enterTips": "Παρακαλώ περάστε",
  "actualAccount": "Πραγματικός λογαριασμός",
  "handlingFee": "Χρέωση υπηρεσίας",
  "confirm": "Επιβεβαιώστε την παραλαβή",
  "previous": "Προηγούμενο βήμα",
  "pleaseEnterAddress": "Εισαγάγετε τη διεύθυνση",
  "pleaseEnterQuantity": "Παρακαλώ εισάγετε την ποσότητα",
  "withdrawSuccess": "Οι παραγγελίες υποβλήθηκαν με επιτυχία",
  "saveQr": "Αποθήκευση κωδικού QR",
  "pleaseEnterAmount": "Εισαγάγετε το ποσό επαναφόρτισης",
  "expectedArrival": "Αναμενόμενη άφιξη",
  "currentRate": "Τρέχουσα ισοτιμία",
  "uploadTips": "Απόδειξη πληρωμής (Μεταφόρτωση στιγμιότυπου οθόνης των λεπτομερειών πληρωμής)",
  "clickUpload": "Κάντε κλικ για μεταφόρτωση",
  "uploadPhoto": "Παρακαλώ ανεβάστε φωτογραφίες",
  "rechargeSuccessful": "Η επαναφόρτιση πέτυχε",
  "rechargeTips": "\"Προτροπή επαναφόρτισης: \"\"Συμπληρώστε με ειλικρίνεια το πραγματικό ποσό μεταφοράς. Διαφορετικά, το σύστημα ενδέχεται να μην περάσει την έγκριση και να επηρεάσει την πρόοδο της επαναφόρτισης.\"",
  "rechargeRecord": "Ρεκόρ επαναφόρτισης",
  "all": "Ολα",
  "pending": "Να πληρωθεί",
  "cancelled": "Ακυρώθηκε",
  "delivered": "Να αποσταλεί",
  "confirmed": "Επιβεβαιωμένος",
  "receipt": "Να παραληφθεί",
  "harvested": "Ελήφθη",
  "comment": "Προς επανεξέταση",
  "refund": "Επιστροφή χρημάτων/μετά την πώληση",
  "cancelOrder": "Ακύρωση παραγγελίας",
  "cancelReason": "Λόγος ακύρωσης",
  "cancelOrderTitle": "Επιλέξτε έναν λόγο ακύρωσης παραγγελίας",
  "returnOrderTitle": "Επιλέξτε τον λόγο επιστροφής",
  "refundInstructions": "Οδηγίες επιστροφής χρημάτων",
  "returnDetailTips": "Δώστε μια κριτική για το προϊόν",
  "cancel": "Ακύρωση παραγγελίας",
  "cancelOrder1": "Το προϊόν δεν παραλήφθηκε",
  "cancelOrder2": "Δεν μου αρέσει, δεν το θέλω",
  "cancelOrder3": "Ο πωλητής έστειλε λάθος προϊόντα",
  "cancelOrder4": "Ψεύτικη μάρκα",
  "cancelOrder5": "Λιγότερη αποστολή, χαμένη αποστολή",
  "cancelOrder6": "Το προϊόν ελήφθη κατεστραμμένο",
  "cancelOrder7": "Υπάρχει πρόβλημα ποιότητας",
  "cancelOrder8": "Διαπραγματευτείτε την επιστροφή χρημάτων με τον έμπορο",
  "cancelOrder9": "Αλλοι λόγοι",
  "cancelOrderSuccess": "Η παραγγελία ακυρώθηκε με επιτυχία",
  "returnOrderSuccess": "Υποβολή με επιτυχία",
  "orderName": "Ονομα",
  "orderEmail": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
  "orderAddress": "Διεύθυνση",
  "orderNation": "Χώρα",
  "orderState": "Κατάσταση",
  "orderCity": "Πόλη",
  "orderPostCode": "Ταχυδρομικός Κώδικας",
  "orderAmount": "Ποσότητα",
  "orderPrefix": "Συνολική παραγγελία",
  "orderFee": "Φόροι",
  "orderSpecification": "Προσδιορισμός",
  "orderCommodity": "Προϊόν",
  "orderQuantity": "Ποσότητα",
  "orderUnitprice": "Τιμή μονάδας",
  "orderFreight": "Φορτίο",
  "orderTax": "Φόρος",
  "orderTotal": "Σύνολο",
  "PaymentOrder": "Σειρά ΠΛΗΡΩΜΗΣ",
  "Evaluate": "Ανασκόπηση",
  "CancelOrder": "Ακύρωση παραγγελίας",
  "RemindShip": "Υπενθύμιση για αποστολή",
  "Refund": "Επιστροφή χρημάτων",
  "Submitareview": "Υποβάλετε κριτικές",
  "Information": "Πληροφορίες",
  "wrongPassword": "Σφάλμα κωδικού πρόσβασης περισσότερες από 3 φορές. Δοκιμάστε ξανά αύριο.",
  "Operate": "Λειτουργία",
  "Item": "Αντικείμενο (α)",
  "From": "Από",
  "hint": "Συμβουλές",
  "CheckDetails": "Δείτε λεπτομέρειες",
  "Payment": "Πληρωμή",
  "Cancel": "Ματαίωση",
  "refundSuccessfully": "Επιτυχής επιστροφή χρημάτων",
  "pendingPayment": "Να πληρωθεί",
  "pay": "Πληρωμή",
  "LoginPassword": "Κωδικός σύνδεσης",
  "sure": "Φυσικά",
  "shippingAddress": "Διεύθυνση παραλαβής",
  "pleaseAddShippingAddress": "Παρακαλώ προσθέστε πρώτα μια διεύθυνση αποστολής",
  "transactionPassword": "Κωδικός συναλλαγής",
  "markDefaultAddress": "Επισήμανση ως προεπιλεγμένη διεύθυνση αποστολής",
  "edit": "Επεξεργάστηκε από",
  "delete": "Διαγράφω",
  "Opt": "Επιλέγω",
  "piece": "τεμ",
  "orderDetails": "Λεπτομέρειες Παραγγελίας",
  "shopCollection": "Προσθέστε το κατάστημα στα αγαπημένα",
  "addAddress": "Προσθήκη νέας διεύθυνσης",
  "signUp": "Εγγραφή",
  "loginTips": "Έχετε ήδη λογαριασμό?",
  "loginIn": "Σύνδεση",
  "mobile": "Τηλέφωνο Αρ",
  '购物车还没有商品': 'Το καλάθι αγορών δεν έχει ακόμη προϊόντα',
  '去购物': 'Πήγαινε για ψώνια',
  "modifyAddress": "Τροποποίηση διεύθυνσης",
  "desc": "Ορισμός ως προεπιλεγμένη διεύθυνση",
  "keep": "Διατηρούν",
  "onlineService": "Διαδικτυακές υπηρεσίες",
  "send": "Στείλετε",
  "EsShop": "Ηλεκτρονικό κατάστημα",
  "desc3": "Εισαγάγετε τον κωδικό συναλλαγής",
  "desc4": "Εισαγάγετε τον κωδικό συναλλαγής σας",
  "desc6": "Εισαγάγετε ξανά τον κωδικό συναλλαγής σας",
  "setUpPayPaw": "Ορισμός κωδικού πρόσβασης συναλλαγής",
  "setSuccess": "Η εγκατάσταση πέτυχε",
  "confirmPayPaw": "Επιβεβαίωση κωδικού πρόσβασης συναλλαγής",
  "paymentSuccessful": "Η πληρωμή ολοκληρώθηκε",
  "paymentPending": "Πληρωμή σε εκκρεμότητα",
  "paymentPendingDesc": "Η πληρωμή σας επεξεργάζεται. Ελέγξτε την κατάσταση της παραγγελίας σας αργότερα",
  "desc5": "Λάθος διεύθυνση αποστολής; Επικοινωνία",
  "customeService": "Ηλεκτρονική εξυπηρέτηση πελατών",
  "BackHome": "Επιστροφή στην αρχική σελίδα",
  "Checkorder": "Προβολή παραγγελίας",
  "ForgotPassword": "Ξεχάσατε τον κωδικό πρόσβασης;",
  "signIn": "Σύνδεση",
  "noAccount": "Δεν υπάρχει αριθμός λογαριασμού;",
  "pleaseEnterAccount": "Εισαγάγετε τον αριθμό λογαριασμού",
  "pleaseEnterPassword": "Παρακαλούμε εισάγετε τον κωδικό πρόσβασης",
  "password": "Κωδικός πρόσβασης",
  "mobilePhone": "Τηλεφωνικό νούμερο",
  "pleaseEnterPhoneNumer": "Ορίστε τον αριθμό τηλεφώνου",
  "setPassword": "Ορίστε κωδικό",
  "noDataFound": "Δε βρέθηκαν δεδομένα",
  "searchCountry": "Εισαγάγετε το όνομα της χώρας και τον κωδικό περιοχής για αναζήτηση",
  "pleaseEnterEmail": "Ρυθμίστε το γραμματοκιβώτιο",
  "invitationCode": "Κωδικός πρόσκλησης",
  "plaeseEnterInvitaionCode": "Ορίστε τον κωδικό πρόσκλησης",
  "pleaseSetLoginPassword": "Ορίστε τον κωδικό πρόσβασης σύνδεσης",
  "selectDeliveryAddress": "Επιλέξτε διεύθυνση αποστολής",
  "totalOf": "Σύνολο",
  "items": "Είδος",
  "orderSummary": "Περίληψη παραγγελίας",
  "paymentMethod": "Μέθοδος πληρωμής",
  "Balance": "Ισορροπία",
  "payPal": "PayPal",
  "notOpen": "Αυτή η μέθοδος πληρωμής δεν είναι ακόμη ανοιχτή στην περιοχή σας",
  "mastercard": "MasterCard",
  "additional": "Επιπλέον",
  "handlingfee": "Απαιτείται χρέωση υπηρεσιών",
  "goodsNumber": "Ποσότητα προϊόντων",
  "deliveryFee": "Φορτίο",
  "totalNum": "Σύνολο",
  "new": "Νέος",
  "oldPassword": "ΠΑΛΙΟΣ ΚΩΔΙΚΟΣ",
  "pleaseEnterOldPassword": "Εισαγάγετε τον παλιό κωδικό πρόσβασης",
  "newPassword": "Νέος Κωδικός",
  "plaseeEnterNewPassword": "Εισαγάγετε τον νέο κωδικό πρόσβασης",
  "confirmPassword": "Επιβεβαίωση Κωδικού",
  "plaseeENterConfirmPassword": "Εισαγάγετε τον κωδικό επιβεβαίωσης",
  "twoPawword": "Δύο κωδικοί πρόσβασης δεν είναι ίδιοι",
  "rechargeAddress": "Διεύθυνση επαναφόρτισης",
  "plaseEnterRechargeAddress": "Εισαγάγετε τη διεύθυνση επαναφόρτισης",
  "userCenter": "Προσωπικό κέντρο",
  "merchantSettled": "Είσοδος εμπόρου",
  "upNew": "Αναφέρεται νέο προϊόν",
  "balanceNot": "Η ισορροπία δεν είναι αρκετή. Παρακαλώ επαναφορτίστε.",
  "NoProductSelected": "Το προϊόν δεν έχει επιλεγεί ακόμα",
  "ShippingAddressNotSet": "Η διεύθυνση αποστολής δεν έχει οριστεί",
  "consigneeName": "Όνομα παραλήπτη",
  "email": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ:",
  "areaCode": "Διεθνής κωδικός περιοχής",
  "phoneNumber": "Τηλεφωνικό νούμερο",
  "nation": "Χώρα",
  "state": "Επαρχία/Πολιτεία/Πολιτεία",
  "city": "Πόλη",
  "postCode": "Ταχυδρομικός Κώδικας",
  "address": "Αναλυτική διεύθυνση",
  "addAddressOrModifyAddress": "Προσθήκη νέας διεύθυνσης/Τροποποίηση διεύθυνσης",
  "setAsTheDefaultAddress": "Ορισμός ως προεπιλεγμένη διεύθυνση",
  "proceed": "Να συνεχίσει",
  "btnSure": "Επιβεβαιώνω",
  "pleaseInput": "Παρακαλώ περάστε",
  "allProduct": "Ολα τα προϊόντα",
  "myCommodityCollection": "Αγαπημένα προϊόντα",
  "myFollowedShops": "Ακολουθήστε το κατάστημα",
  "mySold": "Πωληθεί",
  "myPageviews": "Ποσότητα περιήγησης",
  "myPraiseRate": "Ποσοστό καλών κριτικών",
  "myUnfollow": "Κατάργηση παρακολούθησης",
  "inputNum": "Αριθμοί",
  "inpuEmailErro": "Εισαγάγετε τη σωστή διεύθυνση email",
  "goodsShip": "Αποστολή",
  "goodsShipTips": "Τα προϊόντα θα αποσταλούν εντός 24 ωρών από την τοποθέτηση της παραγγελίας. Εάν υπάρχει έλεγχος logistics για την ακόλουθη παραγγελία, η παραγγελία μπορεί να καθυστερήσει. Παρακαλούμε δώστε προσοχή στις πληροφορίες logistics της παραγγελίας ή επικοινωνήστε με την εξυπηρέτηση πελατών.",
  "goodsFreight": "Φορτίο",
  "goodsFreeShipping": "Δωρεάν",
  "goodsFreightTips1": "1. Σύνθεση διασυνοριακού φορτίου προϊόντος: φορτίο=τέλη αποστολής+μεταφορά μεγάλων αποστάσεων+ τέλος παράδοσης",
  "goodsFreightTips2": "2. Εάν δεν πληρούνται οι όροι αποστολής, το ναύλο χρεώνεται σύμφωνα με τις πραγματικές συνθήκες.",
  "goodsFreightTips3": "3. Το δικαίωμα της τελικής ερμηνείας ανήκει στην πλατφόρμα.",
  "pleaseValidPostCode": "Εισαγάγετε περισσότερα από 4 ψηφία",
  "pleaseValidEmail": "Εισαγάγετε τη σωστή διεύθυνση email",
  "pleaseValidPhone": "Εισαγάγετε τον σωστό αριθμό τηλεφώνου",
  "productAvailable": "Αυτό το προϊόν έχει καταργηθεί",
  "validatorMaxNumber": "Το ποσό υπερβαίνει το όριο",
  "validatorRequire": "Τα υποχρεωτικά στοιχεία δεν μπορούν να είναι μηδενικά",
  "validatorPhone": "Εισαγάγετε τον σωστό αριθμό τηλεφώνου",
  "validatorEmail": "Εισαγάγετε τη σωστή μορφή email",
  "validatorPassword": "Ο κωδικός πρόσβασης αποτελείται από 6-12 ψηφία ή γράμματα(περιέχει ειδικούς χαρακτήρες)",
  "validatorSixNumber": "Εισαγάγετε 6 καθαρά ψηφία",
  "validatorFourMoreNumber": "Εισαγάγετε έναν συνδυασμό 4-32 ψηφίων ή γραμμάτων",
  "validatorIpRule": "Λανθασμένη μορφή IP",
  "validatorChineseAndEnglish": "Μόνο κινέζικα και αγγλικά, εισαγάγετε εύρος: 8-64 χαρακτήρες",
  "collectionSuccess": "Προσθήκη στα αγαπημένα με επιτυχία",
  "followedSuccess": "Η παρακολούθηση πέτυχε",
  "cancelSuccess": "Η ακύρωση πέτυχε",
  "evaluateOrder": "Κριτική με εικόνες",
  "evaluateOrderPlaceholder": "Παρακαλούμε ελέγξτε τα προϊόντα",
  "operationSuccess": "Η επιχείρηση πέτυχε",
  "confirmReceiveGoods": "Επιβεβαιώστε την παραλαβή του προϊόντος ή όχι",
  "evaluateOrderSuccess": "Η κριτική πέτυχε",
  "yesterday": "Εχθές",
  "notLogin": "Δεν έχετε συνδεθεί ακόμα.",
  "delAllHistoryRecord": "Είστε βέβαιοι ότι θέλετε να διαγράψετε όλο το αρχείο ιστορικού;",
  "or": "Ή",
  "tipsRemindsText": "Ο έμπορος θα λάβει μια υπενθύμιση μετά την υπενθύμιση της αποστολής",
  "tipsRemindsCount": "Μπορεί να υπενθυμιστεί μόνο μία φορά.",
  "tipsRemindsMerchant": "Υπενθύμιση στους εμπόρους",
  "tipsRemindsSuccess": "Η υπενθύμιση πέτυχε",
  "noCartTips": "Η τσάντα για τα ψώνια σας είναι άδεια. Ξεκινήστε τις αγορές.",
  "defaultRate": "Το σύστημα προεπιλογή για ευνοϊκές κριτικές",
  "prevPage": "Προηγούμενη σελίδα",
  "nextPage": "Επόμενη σελίδα",
  "returnApply": "Αίτηση επιστροφής χρημάτων",
  "returnReason": "Λόγος επιστροφής χρημάτων",
  "returnAmount": "Ποσό επιστροφής",
  "returnRemark": "Οδηγίες επιστροφής",
  order: {
    confirm: "Επιβεβαιώστε την παραλαβή",
    payment: "Πλήρωσε τώρα",
    remind: "Υπενθύμιση για αποστολή",
    return: "Αίτημα για επιστροφή χρημάτων προϊόντος",
    evaluate: "Επανεξέταση τώρα",
    logistics: "Προβολή logistics",
    noRefund: "Χωρίς επιστροφή χρημάτων",
    refunding: "Επιστροφή χρημάτων σε εξέλιξη",
    refundSuccess: "Επιτυχής επιστροφή χρημάτων",
    refundFail: "Η επιστροφή χρημάτων απέτυχε"
  },
  "remindTitle": "Υπενθύμιση για αποστολή",
  "remindContent": "Αφού υπενθυμιστεί η αποστολή, ο έμπορος θα λάβει την υπενθύμιση. Μπορεί να υπενθυμιστεί μόνο μία φορά.",
  "remindSuccess": "Η υπενθύμιση πέτυχε",
  "remindRepeat": "Αυτή η παραγγελία έχει υπενθυμιστεί.",
  "noComments": "Καμία κριτική προς το παρόν",
  "storeSeach": "Αναζητήστε προϊόν σε αυτό το κατάστημα",
  "storeSeachTips1": "Βρέθηκε για εσάς",
  "storeSeachTips2": "Βρέθηκαν σχετικά καταστήματα",
  "storeSeachTips3": "Σπίτι",
  "creditTit": "Πιστωτικές υπηρεσίες",
  "getCoupons": "Λάβετε περισσότερα κουπόνια",
  "yourEmail": "η ηλεκτρονική σου διεύθυνση",
  "subscription": "Συνδρομές",
  "paymethods": "Μέθοδος πληρωμής",
  "footdec": "Οι παγκόσμιοι χρήστες του {name} προέρχονται από {num} χώρες σε όλο τον κόσμο και χρησιμοποιούν {coin} για διακανονισμό. Το {coin} είναι μια συναλλαγή χωρίς σύνορα που επιτρέπει άμεσες συναλλαγές χαμηλού κόστους σε όλο τον κόσμο χωρίς αναμονή και διεθνείς χρεώσεις.",
  "custService": "Εξυπηρέτηση πελατών",
  "helpLine": "Ηλεκτρονική εξυπηρέτηση πελατών",
  "contactUs": "Επικοινωνήστε μαζί μας",
  "partner": "Συνεταιριστικοί προμηθευτές",
  "buyRules": "Κανόνες αγοραστή",
  "客户端下载":"Λήψεις πελάτη",
  "提现方式": "Μέθοδος απόσυρσης",
  "sellerRules": "Πολιτική πωλητή",
  "returnsAndEx": "Επιστροφές και ανταλλαγή",
  "servicePolicy": "Πολιτική εξυπηρέτησης",
  "returnPolicy": "ΠΟΛΙΤΙΚΗ ΕΠΙΣΤΡΟΦΗΣ ΠΡΟΪΟΝΤΩΝ",
  "user_Center": "Κέντρο χρηστών",
  "userReg": "Εγγραφή χρήστη",
  "orderTrack": "Ερώτημα παραγγελίας",
  "purchageHistory": "Ιστορικό αγορών",
  "myPurse": "Το πορτοφόλι μου",
  "aboutUs": "Σχετικά με εμάς",
  "Recruitment": "Περιμένετε ταλαντούχους ανθρώπους",
  "news": "Πληροφορίες ειδήσεων",
  "stateMent": "Δήλωση σύγχρονης δουλείας",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "οκχ",
  "metaMask": "MetaMask",
  "homeBannertips1": "Γίνε έμπορος",
  "homeBannertips2": "Συνολική προμήθεια",
  "homeBannertips3": "Μέγιστη.",
  "homeBannerbtn": "Πάρε μέρος τώρα",
  "homeDownloadtips1": "Διασυνοριακό εμπορικό κέντρο χονδρικής",
  "homeDownloadtips2": "Ειδική προσφορά μάρκας",
  "homeDownloadtips3": "Έκπτωση χωρίς στάση",
  "homeDownloadtips4": "Λήψη Android",
  "homeDownloadtips5": "Λήψη της Apple",
  "homeDownloadtips6": "Σάρωση κωδικού QR για λήψη της APP",
  "homeIconTips1": "100% Γνήσιο",
  "homeIconTips2": "7 ημέρες επιστροφή",
  "homeIconTips3": "Έκπτωση φορτίου",
  "homeIconTips4": "ασφαλής πληρωμή",
  "headerSearchTips": "Εισαγάγετε λέξη-κλειδί για αναζήτηση",
  "collAccount": "Τρόπος δανείου",
  "mine": "Δικος μου.",
  "creditText1": "Τα δάνεια εκκίνησης λύνουν το πρόβλημα του δανεισμού χρημάτων",
  "creditText2": "Παρέχετε υπηρεσίες δανείου εκκίνησης και κύκλου εργασιών κεφαλαίου",
  "creditWorry": "Δάνειο χωρίς άγχος",
  "creditQuota": "Ευέλικτο όριο",
  "creditQuotaINFO": "100.000 έως 30.000.000 με ευέλικτο όριο και χωρίς περιορισμούς, με μέγιστη διάρκεια δανείου τον ένα χρόνο.",
  "quickLoan": "Γρήγορο δάνειο",
  "creditReview": "Περάστε τον έλεγχο σε μία ώρα το νωρίτερο, εάν ο έλεγχος περάσει, το δάνειο θα αποδεσμευτεί αμέσως.",
  "safe": "Ασφαλές και χωρίς ανησυχίες",
  "safeInfo": "Χωρίς υποθήκη, χωρίς κατάθεση, χωρίς επιστροφή, γιατί αυτό είναι στην πραγματικότητα μια ιδιωτική υπόθεση.",
  "about": "Σχετικά με εμάς",
  "aboutText1": "Δεσμευόμαστε για τις χρηματοοικονομικές υπηρεσίες δανείου, με βάση την επιχειρηματική φιλοσοφία «πρώτα ο πελάτης», έχοντας ως αποστολή την επίλυση του προβλήματος του κύκλου εργασιών των πελατών. Από την ίδρυσή της, η εταιρεία έχει βοηθήσει πολλούς πελάτες να λύσουν το πρόβλημα του κύκλου εργασιών κεφαλαίου.",
  "aboutText2": "Όριο: 100.000-30.000.000, ευέλικτη μέθοδος αποπληρωμής με χαμηλό επιτόκιο, χωρίς προκαταβολή, διαδικτυακό δάνειο, χωρίς τηλεφώνημα για επαλήθευση, εμπιστευτικές πληροφορίες και αυθημερόν δανεισμό.",
  "contactUs1": "Εάν δεν θέλετε να δανειστείτε χρήματα από τους συναδέλφους σας, επικοινωνήστε μαζί μας.",
  "committed": "Δεσμευμένος για υπηρεσίες δανείου επιχειρηματιών",
  "financial": "Αντιμετωπίστε τις οικονομικές σας ανησυχίες",
  "partnersTit": "Συνεργάτης-Διαδικτυακή πλατφόρμα δανεισμού",
  "application": "Αίτηση για δάνειο",
  "applicant": "Αιτών",
  "actualName": "Το πραγματικό του όνομα",
  "yourName": "Εισαγάγετε το όνομα",
  "term": "Διάρκεια δανείου",
  "applicationAmount": "Ποσό που ζητήθηκε",
  "rates": "Επιτόκιο δανείου",
  "loanMethod": "Τρόπος δανείου",
  "accountB": "Υπόλοιπο λογαριασμού",
  "countryOf": "Ιθαγένεια",
  "myloan": "Το δάνειό μου",
  "applyLoan": "Κάντε αίτηση για δάνειο",
  "loaned": "Δανεισμένος",
  "interest": "Συλλογισμένοι τόκοι",
  "esRepayment": "Εκτιμώμενη αποπληρωμή",
  "loanHistory": "Ρεκόρ δανείου",
  "applicantDate": "Ημερομηνία αίτησης",
  "repayment": "Ανταπόδοση",
  "cycle": "Κύκλος αποπληρωμής",
  "fixedRate": "Σταθερό επιτόκιο",
  "successLoan": "Το δάνειο πέτυχε",
  "Reapply": "Κάντε ξανά αίτηση",
  "borrow": "Το δάνειο απέτυχε",
  "applicantIn": "Εφαρμογή σε εξέλιξη",
  "repaid": "Ανταπόδοση",
  "overdue": "Εκπρόθεσμος",
  "estirepay": "Εκτιμώμενη αποπληρωμή",
  "loanDays": "Αριθμός ημερών δανεισμού",
  "reAmount": "Ποσό αποπληρωμής",
  "repay": "Τρόπος αποπληρωμής",
  "entRepay": "Επιβεβαιώστε την εξόφληση",
  "foryourmoney": "Εάν βρίσκεστε σε έλλειψη ταμείου, δεν βρίσκετε πού να δανειστείτε χρήματα ή ντρέπεστε να δανειστείτε χρήματα από τους φίλους σας, μπορείτε να επικοινωνήσετε μαζί μας. Έχουμε όλη τη διαδικασία επαγγελματικής εξυπηρέτησης για να απαντήσουμε στις αμφιβολίες σας ανά πάσα στιγμή. Στόχος μας είναι να κάνουμε κάθε δάνειο διαφανές, ώστε οι πελάτες να μπορούν να το χρησιμοποιούν γρήγορα και με σιγουριά.",
  "onlineApplin": "Υποβάλλετε αίτηση ηλεκτρονικά",
  "businessloan": "Αίτηση για δάνειο εκκίνησης",
  "selectCountry": "Επιλέξτε μια εθνικότητα",
  "selectPeriod": "Επιλέξτε μια περίοδο",
  "passPortImg": "Αριθμός Ταυτότητας/Αριθμός Διαβατηρίου.",
  "uploadId": "Μεταφόρτωση φωτογραφίας/διαβατηρίου πιστοποιητικού",
  "readAndAgree": "Έχω διαβάσει και συμφωνώ",
  "loanAgree": "Δανειακή σύμβαση",
  "submitApplica": "Υποβολή αίτησης",
  "photoExample": "Παράδειγμα λήψης φωτογραφιών",
  "discounted": "Προϊόντα με έκπτωση",
  "days": "ημέρα",
  "privacyPolicy": "Πολιτική απορρήτου",
  "delivery": "Παράδοση και παραλαβή",
  "checkAgreement": "Παρακαλώ σημειώστε τη συμφωνία!",
  "businessPhone": "Τηλέφωνο εργασίας",
  "businessEmail": "Εταιρικό E-mail",
  "提交失败": "Η υποβολή απέτυχε",
  "充值金额不能小于1": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μικρότερο από 1 (συμπεριλαμβανομένων δύο δεκαδικών ψηφίων)",
  "请切换其他语言后查看": "Μεταβείτε σε άλλη γλώσσα για προβολή",
  "我的购物车": "Το καλάθι αγορών μου",
  "推荐商品": "Προτεινόμενα προϊόντα",
  "猜你喜欢": "Μαντέψτε ότι σας αρέσει.",
  "暂无店铺": "Δεν βρέθηκε κατάστημα",
  "添加失败": "Αποτυχία υποβολής. Παρακαλώ δοκιμάστε ξανά αργότερα",
  "提交订单": "Υποβολή παραγγελίας",
  "请选择": "Παρακαλώ επιλέξτε",
  "提款地址绑定": "Διεύθυνση ανάληψης",
  "绑定成功": "Επιτυχής σύνδεση",
  "企业电话": "Τηλέφωνο εργασίας",
  "职业机会": "ευκαιρίες καριέρας",
  "仅能绑定一个收款地址!": "Μόνο μια διεύθυνση πληρωμής μπορεί να συνδεθεί!",
  "最多包含10位小数": "Μέχρι 10 δεκαδικά ψηφία",
  footTipTikTok:'CoveBuy Mall ©️2024 Πνευματικά δικαιώματα',
  TikTokFoot:"Το CoveBuy Mall είναι μια παγκόσμια πλατφόρμα κοινωνικής δικτύωσης μικρού μήκους βίντεο, η CoveBuy και η μεγαλύτερη εταιρεία χονδρικής εμπορίας της Ασίας Alibaba, που ιδρύθηκε σε συνεργασία. Είναι μια παγκόσμια πλατφόρμα ηλεκτρονικού εμπορίου και διαθέτει τρεις αυτολειτουργούμενες έξυπνες αποθήκες στον κόσμο, που βρίσκονται στο Τορόντο του Καναδά, στο Λος Άντζελες και στην Τσίμπα της Ιαπωνίας. Τα προϊόντα που πωλούνται στην εφαρμογή περιλαμβάνουν δημοφιλή προϊόντα από την Ιαπωνία, τη Νότια Κορέα, την Κίνα και άλλες ασιατικές χώρες. Προς το παρόν, ο συνολικός αριθμός έχει ξεπεράσει τις 50.000 και συνεχίζει να αυξάνεται ραγδαία.",
  "betaBannerText": "Η ιστοσελίδα βρίσκεται σε δημόσια δοκιμή, παρακαλώ μην κάνετε παραγγελίες"
}